module.exports = __webpack_public_path__ + "static/couch-2cddc66f7fcfd672d6d03cdb3afc4486.png";